import * as React from "react";
import PropTypes from 'prop-types';

const SvgRebate = props => {
  if (props.id !== "_svgrebate") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 41 40" {...props}><path d="M33.8 17.18a3.152 3.152 0 01-.92.13 3.362 3.362 0 01-3.38-3.35c0-.34.054-.677.16-1h3.7c.21 0 .42.32.42.53l.02 3.69zm0 9.35a.718.718 0 01-.56.53h-3.52a3.471 3.471 0 01-.22-1.07 3.36 3.36 0 013.4-3.3c.29-.002.578.032.86.1l.04 3.74zm-9.7-4.56a2.62 2.62 0 01-2.6 2.6v1.24a.85.85 0 01-1.69 0V24.5a5.56 5.56 0 01-2.62-1.31l.94-1.11a4.18 4.18 0 002.83 1.17c1 0 1.58-.46 1.58-1.11 0-.63-.36-1-2-1.35-1.89-.45-3-1-3-2.63a2.54 2.54 0 012.26-2.48v-1.49a.85.85 0 011.69 0v1.4c.85.125 1.654.47 2.33 1l-.85 1.17a4.057 4.057 0 00-2.41-.9c-.92 0-1.46.46-1.46 1 0 .68.41 1 2.13 1.38 1.88.46 2.85 1.13 2.85 2.59l.02.14zM8.03 17.31a3.85 3.85 0 01-.83-.06v-3.74a.77.77 0 01.56-.57h3.47c.11.322.167.66.17 1a3.37 3.37 0 01-3.37 3.37zm3.16 9.75H7.76a.77.77 0 01-.56-.57v-3.71c.252-.06.51-.09.77-.09a3.352 3.352 0 013.4 3.3c.001.364-.06.726-.18 1.07zm22.19-15.81H7.76a2.411 2.411 0 00-2.26 2.26v13a2.41 2.41 0 002.26 2.24h25.48a2.36 2.36 0 002.26-2.22V13.47a2.23 2.23 0 00-2.12-2.22z" /></svg>;
};

SvgRebate.displayName = "_svgrebate";
SvgRebate.propTypes = {
  id: PropTypes.string
};
SvgRebate.defaultProps = {
  id: ''
};
export default SvgRebate;